import { render } from "./SinglePortfolio.vue?vue&type=template&id=8f39612c&scoped=true"
import script from "./SinglePortfolio.vue?vue&type=script&lang=js"
export * from "./SinglePortfolio.vue?vue&type=script&lang=js"

import "./SinglePortfolio.vue?vue&type=style&index=0&id=8f39612c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f39612c"]])

export default __exports__